import React, { Component } from 'react';
import Countdown from 'react-countdown-now';
import './SessionExpirationWarning.scss';

import Dialog from '../Dialogs/Dialog';

export default class SessionExpirationWarning extends Component {
  constructor(props) {
    super(props);

    this.dialogRefs = React.createRef();
  }

  render() {
    // eslint-disable-next-line no-unused-vars
    const renderer = ({ hours, minutes, seconds, completed }) => {
      return (
        <Dialog
          ref={this.dialogRefs}
          onClose={this.props.onContinue}
          title="Your session about to expire"
          closeButton="false"
          closeButtonText="Continue"
        >
          <span>
            <p>
              For the security of your information, your session will time out
              in&nbsp;
              <span className="seconds">{seconds}</span>&nbsp;seconds.
            </p>
            <span>
              Please click <em>Continue</em> to continue your session.
            </span>
          </span>
        </Dialog>
      );
    };

    return (
      <Countdown
        date={Date.now() + this.props.seconds * 1000}
        renderer={renderer}
        onComplete={this.props.onExpired}
        onContinue={this.props.onContinue}
      />
    );
  }
}
